import { useField } from 'formik'

import { maskMapper } from 'main/src/components/Input/InputWithMaskValidation/utils'

import MaskedInput from 'main/src/components/Input/MaskedInput/InputMask'

export interface InputProps {
  className?: string
  mask: string
  name: string
  placeholder: string
  type: string
  value?: string
}

export const Input = ({ className, mask, name, placeholder, type, value }: InputProps) => {
  const id = `input-${name}`
  const [field, meta] = useField(name)
  const ariaInvalid = !!(meta.error && meta.touched)
  const inputProps = {
    ...field,
    placeholder,
    type,
    value,
    id,
    className,
  }

  return (
    <MaskedInput
      {...inputProps}
      mask={maskMapper(mask)}
      maskPlaceholder={null}
      aria-invalid={ariaInvalid}
    />
  )
}
